// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-shoppers-place{
    background: #a3a3a3;
    border-radius: 8px;
    padding: 10px 8px;
    margin-bottom: 10px;
    margin-left: 0.1%;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/views/professionals/Professionals.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB","sourcesContent":[".card-shoppers-place{\n    background: #a3a3a3;\n    border-radius: 8px;\n    padding: 10px 8px;\n    margin-bottom: 10px;\n    margin-left: 0.1%;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
